import { Injectable } from '@angular/core';
import { NgbTimeAdapter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';

/**
 * This adapter is used to convert values when using ngb-timepicker.
 */
@Injectable({providedIn: 'root'})
export class TimePickerStringAdapter extends NgbTimeAdapter<string> {

  /**
   * Converts time from string to NgbTimeStruct.
   * For example, it would convert '09:03' to new NgbTime(9, 3, 0).
   * @param value time as string
   */
  fromModel(value: string): NgbTimeStruct {
    if (!value) {
      return null;
    }
    const split = value.split(':');
    return {
      hour: parseInt(split[0], 10),
      minute: parseInt(split[1], 10),
      second: 0,
    };
  }

  /**
   * Converts time from NgbTimeStruct to string.
   * For example, it would convert new NgbTime(9, 3, 0) to '09:03'.
   * @param time date as NgbTimeStruct
   */
  toModel(time: NgbTimeStruct): string {
    if (!time) {
      return null;
    }

    return `${this.pad(time.hour)}:${this.pad(time.minute)}`;
  }

  private pad(i: number): string {
    return i < 10 ? `0${i}` : `${i}`;
  }
}
